import React, { Component } from 'react';
import FilterModal from './Filters/FilterModal';
import FilterLawyerFirm from './Filters/FilterLawyerFirm';
import AddLawyerFirm from './AddLawyerFirm/AddLawyerFirm';
import AddLawyerFirmModal from './AddLawyerFirm/AddLawyerFirmModal';
import LawyerFirmList from './LawyerFirmList';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import Snackbar from '../../components/Snackbar';
import { Grid, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    grid: {
        justifyContent: 'space-between',
        margin: '0 0 16px 40px',
        width: '87.4%',
    },
    title: {
        color: '#10587f',
        fontSize: 32,
        fontWeight: 'bold',
        margin: '15px 0 33px 0',
    },
    buttonsContainer: {
        display: 'flex',
        margin: '15px 0 0 0',
    },
    showAll: {
        width: 168,
        height: 40,
        borderRadius: 20,
        border: '1px solid #013957',
        textTransform: 'inherit',
        backgroundColor: 'transparent',
        color: '#013957',
        fontSize: 16,
        margin: '0 24px 0 0',
    },
    filterButton: {
        width: 120,
        height: 40,
        borderRadius: 20,
        border: '1px solid #013957',
        textTransform: 'inherit',
        backgroundColor: 'transparent',
        color: '#013957',
        fontSize: 16,
        margin: '0 24px 0 0',
    },
    filterIcon: {
        margin: '0 10px 0 0',
    },
    arrow: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    arrowText: {
        color: '#013957',
        fontSize: 14,
        margin: '0 0 0 5px',
        fontWeight: 'bold',
    },
    addLawyerFirm: {
        width: 168,
        height: 40,
        borderRadius: 20, 
        textTransform: 'inherit',
        backgroundColor: '#013957',
        color: 'white',
        fontSize: 16,
        '&:hover': {
            backgroundColor: '#35b9b6',
        }
    },
})

class AdminLawyerFirm extends Component {

    state = {
        showFilter: true,
        flagEvery: false,
        openFilterModal: false,
        showAddLawyerFirm: false,
        openAddLawyerFirmModal: false,
        feedbackMessage: {
            open: false,
            message: '',
            variant: 'success',
        }
    }

    handleShowFilter = () => {
        const { showFilter } = this.state
        this.setState({
            showFilter: !showFilter
        })
    }

    handleOpenFilter = () => {
        this.setState({
            showFilter: true
        })
    }

    handleFlagEvery = (flag) => {
        this.setState({
            flagEvery: flag
        })
    }

    handleShowAddLawyerFirm = (flag) => {
        this.setState({
            showAddLawyerFirm: flag
        })
    }

    handleAddLawyerFirmModal = () => {
        const { openAddLawyerFirmModal } = this.state
        this.setState({
            openAddLawyerFirmModal: !openAddLawyerFirmModal
        })
    }

    searchEvery = () => {
        const { showLoading, hideLoading } = this.props
        showLoading()
        console.log('search every');
        this.setState({
            openFilterModal: false,
            showFilter: false,
            flagEvery: true,
            showAddLawyerFirm: false,
        })
        hideLoading()
    }

    addLawyerFirm = (event) => {
        const { showFilter } = this.state
        if (showFilter) {
            this.handleShowAddLawyerFirm(true)     
        } else {
            this.handleAddLawyerFirmModal()
        }
    }

    handleFilterModal = () => {
        const { openFilterModal } = this.state;
        this.setState({
            openFilterModal: !openFilterModal
        })
    }

    handleSnack = () => {
        const { feedbackMessage } = this.state;
        this.setState(prev => ({
            feedbackMessage: {
                ...prev.feedbackMessage,
                open: !feedbackMessage.open,
                message: '¡Listo! Despacho creado',
            }
        }))
    }

    render() {
        const { showFilter, openFilterModal, showAddLawyerFirm, flagEvery, openAddLawyerFirmModal, feedbackMessage } = this.state;
        const { classes } = this.props;
        
        return (
            <div className={classes.container}>
                <Grid
                    container
                    direction='row'
                    className={classes.grid}
                >
                    {showAddLawyerFirm ?
                        <div 
                            className={classes.arrow}
                            onClick={() => this.handleShowAddLawyerFirm(false)}
                        >
                            <img
                                src="/img/admin/arrow-back.svg"
                                alt="arrow-back"
                            />
                            <p className={classes.arrowText}>Regresar</p>
                        </div> :
                        <p className={classes.title}>
                            {flagEvery && !showFilter ?
                                'Todos los despachos' :
                            showFilter ?
                                'Despachos' :
                                'Resultados de búsqueda'
                            }
                        </p>
                    }

                    {!showAddLawyerFirm ?
                        <div className={classes.buttonsContainer}>
                            {showFilter ?
                                <Button
                                    type="button"
                                    onClick={this.searchEvery}
                                    className={classes.showAll}
                                >
                                    Mostrar todos
                                </Button> :
                                <Button
                                    type="submit"
                                    onClick={this.handleFilterModal}
                                    className={classes.filterButton}
                                >
                                    <img
                                        src='/img/icons/filters.svg'
                                        alt='filter'
                                        className={classes.filterIcon}
                                    />
                                    Filtros
                                </Button>
                            }
                            <Button
                                type="submit"
                                onClick={this.addLawyerFirm}
                                className={classes.addLawyerFirm}
                            >
                                Agregar despacho
                            </Button>
                        </div> : null
                    }
                </Grid>
                {showAddLawyerFirm ?
                    <AddLawyerFirm
                        handleShowAddLawyerFirm={this.handleShowAddLawyerFirm}
                        handleOpenFilter={this.handleOpenFilter}
                        searchEvery={this.searchEvery}
                        handleSnack={this.handleSnack}
                    /> :
                showFilter ?
                    <FilterLawyerFirm
                        handleShowFilter={this.handleShowFilter}
                        handleFlagEvery={this.handleFlagEvery}
                    /> :
                    <LawyerFirmList />
                }
                <FilterModal
                    open={openFilterModal}
                    handleClose={this.handleFilterModal}
                    content={
                        <FilterLawyerFirm
                            isModal
                            showEvery
                            searchEvery={this.searchEvery}
                            handleClose={this.handleFilterModal}
                            handleFlagEvery={this.handleFlagEvery}
                        />
                    }
                />
                <AddLawyerFirmModal
                    open={openAddLawyerFirmModal}
                    handleClose={this.handleAddLawyerFirmModal}
                    content={
                        <AddLawyerFirm
                            handleShowAddLawyerFirm={this.handleShowAddLawyerFirm}
                            handleOpenFilter={this.handleOpenFilter}
                            handleClose={this.handleAddLawyerFirmModal}
                            handleSnack={this.handleSnack}
                            isModal
                        />
                    }
                />
                <Snackbar
                    open={feedbackMessage.open}
                    variant={feedbackMessage.variant}
                    message={feedbackMessage.message}
                    handleClose={this.handleSnack}
                    vertical="top"
                    horizontal="right"
                    snackbarTop={'80px'}
                />
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
})

const AdminLawyerFirmCompose = compose(
    connect(null, mapDispatchToProps),
    withStyles(styles)
)(AdminLawyerFirm)

export default AdminLawyerFirmCompose;
